import * as Scrivito from "scrivito";
import classNames from "classnames";
import { isBrowser } from "^/utils/isBrowser";
import GenericInputComponent from "../GenericInputComponent";
import FormFieldWrapper from "../FormFieldWrapper";
import ErrorBlock from "../ErrorBlock";
import { getValidationResult } from "../../formHelpers";

class ReceiverEmailInputWidgetComponent extends GenericInputComponent {
  // componentDidMount () {
  //   const { widget } = this.props;
  //   widget.update({ propertyName: "email" })
  // }

  render() {
    const { widget, inputsWithErrors } = this.props;
    const placeholder = widget.get("placeholder");

    const myStorage = isBrowser ? window.sessionStorage : {};
    const validation = getValidationResult(inputsWithErrors, widget.id());

    return (
      <>
        <div
          className={classNames("form-group", {
            invalid: !!validation,
          })}
        >
          <FormFieldWrapper widget={widget} inputsWithErrors={inputsWithErrors}>
            <input
              className="form-control"
              id={widget.id()}
              placeholder={placeholder}
              type="text"
              onChange={this.handleInputChange}
              value={myStorage.getItem(widget.id()) || ""}
            />
          </FormFieldWrapper>
        </div>
        <ErrorBlock validation={validation} lang={widget.obj().language()} />
      </>
    );
  }
}

Scrivito.provideComponent(
  "ReceiverEmailInputWidget",
  ReceiverEmailInputWidgetComponent
);
